<template>
	<v-list class="sidebar-list pa-0 pt-10">

		<v-list-item
			v-for="resourceItem in resourcesItems"
			:key="resourceItem.link_id"
			class="sidebar-list__item"
		>
			<v-list-item-content class="sidebar-list__content d-flex">
				<v-divider class="mb-5"/>

				<a
					class="text-decoration-none d-flex pl-3 align-center"
				>
					<a
						:href="link(resourceItem.link_url)"
						:title="resourceItem.link_title"
						target="_blank"
						class="upload-note mr-4 mb-2"
						:style="{ 'background-color': fileIconColor(resourceItem) }"
					>
						<p class="upload-type">
							{{ fileIconName(resourceItem) }}
						</p>
					</a>

					<a
						:href="link(resourceItem.link_url)"
						target="_blank"
					>
						<div class="black--text">
							<div 
								class="text-decoration-underline mb-2" 
								style="font-size: 15px; color: var(--ceil-detail-text-color);"
							>
								{{resourceItem.link_title}}
							</div>
						</div>
					</a>
				</a>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'LinkList',
	data () {
		return {
			fileColors: [
				{ color: '#41a8e1', ext: ['url'] },
			],
		}
	},
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		}
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'breadCrumbs']),
	},
	methods: {
		...mapActions('resources', ['breadCrumbHandler']),

		fileIconColor() {
			const extName = this.fileIconName()
			const colorDataObj = extName && this.fileColors.find((i) => i.ext.indexOf(extName) > -1)

			return colorDataObj ? colorDataObj.color : '#8b8b8b'
		},
		fileIconName() {
			return 'url'
		},
		link(link) {
			const isCustomLink = link.includes('http://') || link.includes('https://')
			if (isCustomLink) {
				return link
			} else {
				const match = link.match(/:\/\/(.*)/)
				return match ? `${window.location.origin}/webapp/${match[1]}` : link
			}
		}
	}
}
</script>

<style lang="scss">
.popular-post-by-category {
	color: #37474f;
	padding: 18px 10px 16px 20px;
	border-radius: 11px;
	margin-bottom: 16px;
	width: 100%;
	background: #e2f2e9;
	box-shadow: none !important;

	&__title {
		padding-bottom: 25px;
		p {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: bold;
			font-size: 14px;
			line-height: 17px;
			letter-spacing: 0.35px;
			color: #202232;
		}

		a {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 15px;
			text-align: center;
			letter-spacing: 0.35px;
			color: #000 !important;
			mix-blend-mode: normal;
			opacity: 0.4;
			text-decoration: none;

			&:hover {
				opacity: 1;
				text-decoration: underline;
			}
		}
	}

	&__thing-title {
		.thing-link {
			font: 500 16px/1.5 'Montserrat';
		}
	}

	&__user-name {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 20px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
		word-break: break-all;
	}
	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__user-location {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
	}

	&__link {
		font: 500 16px/1.5 'Montserrat';
		text-decoration: none;
		color: #37474f !important;

		&:hover {
			transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
			color: black !important;
			text-decoration: underline;
		}
	}
}
</style>
